(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav"] && !Shopify.designMode) return;
  try {
    
(function() {
  var navEl = document.getElementById('snav-{{ section.id }}');
  if (!navEl) return;
  var btns = Array.prototype.slice.call(navEl.querySelectorAll('.snav__btn'));

  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      btns.forEach(function(b) { b.classList.remove('snav__btn--active'); });
      btn.classList.add('snav__btn--active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_hero"]) return;
  try {
    
(function () {
  /* ── OVERVIEW ACCORDION ──
     Encontra o bloco de descrição dentro do product-details
     e envolve-o num accordion clicável
  */
  document.addEventListener('DOMContentLoaded', function () {
    /* Tenta encontrar o container dos detalhes */
    var detailsEl = document.getElementById('product-details')
      || document.querySelector('[id*="product-details"]')
      || document.querySelector('._product-details');

    if (!detailsEl) return;

    /* Procura o bloco de texto com a descrição (último bloco de texto) */
    var rteBlocks = detailsEl.querySelectorAll('.rte, [class*="product-description"]');
    if (!rteBlocks.length) return;

    var descBlock = rteBlocks[rteBlocks.length - 1];
    var parent    = descBlock.closest('[data-block-type]') || descBlock.parentElement;
    if (!parent) return;

    /* Cria o accordion */
    var toggle = document.createElement('button');
    toggle.className    = 'pi-ov-toggle';
    toggle.type         = 'button';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML    =
      '<span class="pi-ov-toggle-label">Overview</span>' +
      '<span class="pi-ov-chevron">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">' +
          '<path d="M3 5L7 9L11 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</span>';

    var body = document.createElement('div');
    body.className = 'pi-ov-body';

    /* Move o conteúdo para dentro do body */
    parent.insertBefore(toggle, descBlock);
    body.appendChild(descBlock);
    parent.appendChild(body);

    toggle.addEventListener('click', function () {
      var open = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!open));
      body.classList.toggle('is-open', !open);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
